import { render, staticRenderFns } from "./TableTotals.vue?vue&type=template&id=82519c6e"
import script from "./TableTotals.vue?vue&type=script&lang=js"
export * from "./TableTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports